import * as Types from '../actions';

export interface AuthReducer {
  error?: string;
  loading: boolean;
  loggedIn: boolean;
  session?: any;
  user?: any;
}

const initialState: AuthReducer = {
  error: undefined,
  loading: false,
  loggedIn: false,
  session: undefined,
  user: undefined,
};

export default (
  state = initialState,
  action: Types.AuthAction
): AuthReducer => {
  switch (action.type) {
    case Types.LOGIN_REQUEST:
    case Types.LOGOUT_REQUEST:
      return { ...state, error: undefined, loading: true };
    case Types.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loggedIn: true,
        session: action.payload.session,
        user: action.payload.user,
      };
    case Types.LOGIN_FAILURE:
    case Types.LOGOUT_FAILURE:
      return { ...state, error: action.error, loading: false };
    case Types.LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};
